import type { ReactElement } from 'react'
import { Route } from 'react-router-dom'
import { AreaGate } from '../../core/areas/AreaGate'
import { flattenNav } from '../../core/router/navConfig'
import { PlaceholderPage } from '../../shared/components/PlaceholderPage'
import {
  ArquivosPage, AssinaturaPontoPage, AusenciasPage, BonusPage, CnhPage, ColaboradoresPage, DesligamentosPage, DpInicioPage, ExamesPage,
  FeriasPage, MultasPage, ParametrosPage, PlanoSaudePage, SinistrosPage,
  ToxicologicoPage, ValeAlimentacaoPage,
  ContratacoesPage,
  comPermissao,
  RotinasPage,
  ConferenciaFolhaPage,
} from '../../core/router/telas'
import { dpNav } from './nav'

const RAIZ = '/dp'

/** Registro path → componente dos itens do menu do DP. Item sem entrada aqui cai no
 *  PlaceholderPage automaticamente. */
const PAGES: Record<string, ReactElement> = {
  '/dp': <DpInicioPage />,
  '/dp/assinatura-do-ponto': <AssinaturaPontoPage />,
  '/dp/vale-alimentacao': <ValeAlimentacaoPage />,
  '/dp/ferias': <FeriasPage />,
  '/dp/desligamentos': <DesligamentosPage />,
  '/dp/plano-de-saude': <PlanoSaudePage />,
  '/dp/exames': <ExamesPage />,
  '/dp/cnh': <CnhPage />,
  '/dp/toxicologico': <ToxicologicoPage />,
  '/dp/contratacoes': <ContratacoesPage />,
  '/dp/bonus': <BonusPage />,
  '/dp/arquivos': <ArquivosPage />,
  '/dp/rotinas': <RotinasPage />,
  '/dp/conferencia-da-folha': <ConferenciaFolhaPage />,
  // As multas que o Abastecimento lança, só para leitura no DP (27/10/2026).
  '/dp/multas': <MultasPage somenteLeitura />,
  // O lote de 01/11/2026.
  '/dp/ausencias': <AusenciasPage />,
  '/dp/parametros': <ParametrosPage />,
  '/dp/colaboradores': <ColaboradoresPage />,
  '/dp/sinistros': <SinistrosPage somenteLeitura />,
}

/** As rotas da área DP, cada tela com o portão da key que o item do menu declara,
 *  pelo roteiro de docs/areas/05-como-adicionar.md. */
export function rotasDoDp(): ReactElement {
  return (
    <Route path={RAIZ} element={<AreaGate area="dp" />}>
      {flattenNav(dpNav).map((item) => {
        const tela = comPermissao(item, PAGES[item.path] ?? <PlaceholderPage title={item.label} />)
        // O Início é a raiz da área: entra como índice, os módulos com o próprio endereço.
        return item.path === RAIZ
          ? <Route key={item.path} index element={tela} />
          : <Route key={item.path} path={item.path} element={tela} />
      })}
    </Route>
  )
}
